// redux/store.ts
import { configureStore } from "@reduxjs/toolkit";
import snackbarReducer from "../slices/snackbarSlice";
import faqReducer from "../slices/faqSlice";
import libraryReducer from "../slices/librarySlice";
import categoryReducer from "../slices/categorySlice";
import categoryTypeReducer from "../slices/categoryTypeSlice";
import landingPageReducer from "../slices/landingPageSlice";
import adminReducer from "../slices/adminSlice";
import roleReducer from "../slices/roleSlice";
import moduleReducer from "../slices/moduleSlice";
import blockSnackbarReducer from "../slices/blockingSnackbarSlice";

export const store = configureStore({
  reducer: {
    snackbar: snackbarReducer,
    faq: faqReducer,
    library: libraryReducer,
    category: categoryReducer,
    categoryType: categoryTypeReducer,
    landingPage: landingPageReducer,
    admin: adminReducer,
    role: roleReducer,
    module: moduleReducer,
    blockingSnackbar: blockSnackbarReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
